export default __webpack_public_path__ + "static/media/model_R_curve.139ec627.png";